import React from 'react';
import DefaultLayout from './DefaultLayout';
import CmaLayout from './CmaLayout';
import DifrLayout from './DifrLayout';
import { Consts } from '../../../../res';

const ExamLayout = (props) => {

    const renderLayout = () => {
        switch (props.theme) {
            case Consts.EXAM_THEMES.CMA:
                return <CmaLayout {...props} />;
            case Consts.EXAM_THEMES.DIFR:
                return <DifrLayout {...props} />;
            default:
                return <DefaultLayout {...props} />;
        }
    };

    return renderLayout();
};

export default ExamLayout;